import { useEffect, useRef, useState } from "react";
import { useMotionValue, animate, useInView } from "framer-motion";

export default function AnimatedCounter({
  value,
  suffix = "",
  duration = 2,
  className,
  "data-testid": dataTestId,
}) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-50px" });
  const mv = useMotionValue(0);
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    if (!inView) return undefined;
    const controls = animate(mv, value, {
      duration,
      ease: "easeOut",
      onUpdate: (latest) => setDisplay(Math.floor(latest)),
    });
    return () => controls.stop();
  }, [inView, value, duration, mv]);

  return (
    <span ref={ref} data-testid={dataTestId} className={className}>
      {display}
      {suffix}
    </span>
  );
}
